import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'AgencyAnalytics Case Study | Canny';
const Description =
  'Read about how AgencyAnalytics uses Canny to earn more revenue and avoid churn.';
const Image = 'https://canny.io/images/50b715416e612f52cf5735ff6f79f2a2.jpg';
const AgencyanalyticsUrl = 'https://canny.io/case-studies/agencyanalytics';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${AgencyanalyticsUrl}#webpage`,
    url: AgencyanalyticsUrl,
    name: 'Case Study: AgencyAnalytics × Canny',
    description: 'How AgencyAnalytics uses Canny to earn more revenue and avoid churn.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${AgencyanalyticsUrl}#article`,
    genre: 'Case Study',
    headline: 'How AgencyAnalytics uses Canny to earn more revenue and avoid churn',
    description:
      'AgencyAnalytics replaced spreadsheets with Canny to collect requests from educated customers across boards and tags. They assess feedback by MRR and churn risk, and deliver $120K/month in customer-requested MRR—directly attributing features built to retention and revenue gains.',
    inLanguage: 'en',
    url: AgencyanalyticsUrl,
    mainEntityOfPage: { '@id': `${AgencyanalyticsUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'AgencyAnalytics', url: 'https://agencyanalytics.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'AgencyAnalytics', item: AgencyanalyticsUrl },
  ]),
]);

export default class AgencyAnalyticsLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },
          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: AgencyanalyticsUrl },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
